import axios from "axios";
import { resolveApiBaseUrl } from "./api-base-url";
import { applyCsrfHeader } from "./csrf";
import { toApiError } from "./api-errors";

export { getApiErrorMessages, toApiError } from "./api-errors";

export const authApi = axios.create({
    baseURL: resolveApiBaseUrl(),
    withCredentials: true
});

authApi.interceptors.request.use((config) => applyCsrfHeader(config));

authApi.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(toApiError(error))
);
